import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ResourceService, MessageService, LabRequestService, UserService } from 'src/app/services';
import { AccessUserInfo, UserDetail } from 'src/app/models';
import { FileUpload } from 'primeng/fileupload';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';

@Component({
  selector: 'bart-resources-search',
  templateUrl: './resources-search.component.html',
  styleUrls: ['./resources-search.component.scss'],
  providers: [ConfirmationService, DialogService, DynamicDialogConfig]
})
export class ResourcesSearchComponent implements OnInit {
  public isEdit: boolean = false;
  public hidePreview: boolean = true;
  public bartRoleCode: string;
  displayPreviewContent: boolean = false;
  dispModelConfirm: boolean = false;  // show Model confirm popup
  public isActiveFlag: any = 0;
  public fileName: string = null;
  public Header: string = null;
  public Content: string = null
  public loading: boolean = false;
  public AvailableFilesDataSource: SelectItem[];
  @ViewChild('fileInput', { static: false }) fileInput: FileUpload;
  userDetail: any = null;
  uploadedFiles: any[] = [];
  public uplo: File;
  ObjGetResources: Object;
  ObjResourceFile: Object;
  public resourcesPreview: string = null;
  public displayAdminForm: boolean = false;
  public displaypreviewContent: boolean = false;
  public displayResourcesContent: boolean = false;
  isDisabled: boolean = true;
  public resourceWikiId: number;
  public htmlContent: string;
  public ResourcesSPDataSource: any[];
  public ResourceFilesDataSource: any[];
  public ResourcesDataSource: any[];
  public WikiContentsDataSource: any[];
  public isLabResource: boolean = false;
  public editLableText: string;
  public noRechtmlContent: string;
  public userInfo: UserDetail;
  constructor(private resourceService: ResourceService, private messageService: MessageService,
    private confirmationService: ConfirmationService, public dialogConfig: DynamicDialogConfig,
    private labRequestService: LabRequestService, private _userService: UserService) {
    let userInfo: UserDetail = AccessUserInfo.getUserInfo();
    if (userInfo != null) {
      this.bartRoleCode = userInfo.bartRoleCode
      this.userInfo = userInfo;
    }
  }

  ngOnInit() {
    this.labRequestService.fromHelpSubject.subscribe(res => {

      if (res == true) {
        this.editLableText = 'Edit Help';
        this.isLabResource = true;
      }
      else {
        this.editLableText = 'Edit Resources';
        this.isLabResource = false;
      }

    })
    this.displayAdminForm = true
    this.displaypreviewContent = true;
    this.userDetail = AccessUserInfo.getUserInfo();
    this.getActiveResources();
    this.loadResourcesSP();
    this.getAvailableFies();
  }

  //Upload Files 
  onUpload(event, fileInput) {

  }

  //Get AvailableFiles
  getAvailableFies() {
    this.resourceService.AvailableFiles()
      .subscribe((resourceResponse: any) => {
        this.AvailableFilesDataSource = [];
        if (resourceResponse.length > 0) {
          for (let c of resourceResponse) {
            this.AvailableFilesDataSource.push({
              label: c.FileName,
              value: null,
            });
          }
        }
      });
  }

  onChangeresourceWikiHistory() {
    this.isEdit = false;
    this.hidePreview = false;
    if (this.resourceWikiId > 0) {
      this.ObjGetResources = {
        "GETRESOURCESSP": {
          "isActiveFlag": 0,
          "ResourceWikiId": this.resourceWikiId,
          "IsLabResource": this.isLabResource
        }
      };
      this.getResourcesContents(this.ObjGetResources);
      this.isDisabled = false;
      this.displayAdminForm = true
      this.displaypreviewContent = false;
      this.displayResourcesContent = true;
    }
    else {
      this.isDisabled = true;
      this.isEdit = false;
      this.hidePreview = true;
      this.getActiveResources();
      this.displayResourcesContent = false;

    }
  }

  //Get Active Resources
  public getActiveResources() {
    this.ObjGetResources = {
      "GETRESOURCESSP": {
        "isActiveFlag": 1,
        "ResourceWikiId": 0,
        "IsLabResource": this.isLabResource
      }
    };
    this.getResourcesContents(this.ObjGetResources);
  }

  //getResources
  public loadResourcesSP() {
    this.ObjGetResources = {
      "GETRESOURCESSP": {
        "isActiveFlag": 0,
        "ResourceWikiId": 0,
        "IsLabResource": this.isLabResource
      }
    };
    this.getResourcesSP(this.ObjGetResources);
  }

  //Get Resources For Dropdown
  public getResourcesSP(ObjGetResources: object) {
    this.loading = true;
    this.resourceService.getResourcesSP(JSON.stringify(ObjGetResources))
      .subscribe((resourceResponse: any) => {
        this.ResourcesSPDataSource = [];
        this.ResourcesSPDataSource.push({
          label: "- Choose Resource Item -",
          value: -1
        });
        if (resourceResponse.length > 0) {
          for (let c of resourceResponse) {
            this.ResourcesSPDataSource.push({
              label: c.formattedDate + ' by ' + c.userName,
              value: c.ResourceWikiId,
            });
          }
        }

        this.loading = false;
      });
  }

  //Get Resources Contents
  public getResourcesContents(ObjGetResources: object) {
    this.htmlContent = '';
    this.noRechtmlContent = '';
    this.loading = true;
    this.resourceService.getResourcesSP(JSON.stringify(ObjGetResources))
      .subscribe((resourceResponse: any) => {
        this.WikiContentsDataSource = [];
        if (resourceResponse.length > 0) {
          this.WikiContentsDataSource = resourceResponse;
          this.htmlContent = this.WikiContentsDataSource[0].htmlContent;
          this.resourcesPreview = this.WikiContentsDataSource[0].formattedDate + ' by ' + this.WikiContentsDataSource[0].userName
          this.loading = false;
        }
        else {
          this.WikiContentsDataSource = null;
          this.loading = false;
        }

      }, (respose: Response) => {
        this.WikiContentsDataSource = [];
        this.loading = false;
        // handle error here
      });
  }

  // Available Files  
  public loadResourceFiles() {

    this.ObjResourceFile = {
      "GETRESOURCEFILES": {
      }
    };
    this.getResourceFiles(this.ObjResourceFile);
  }
  getResourceFiles(resourceFileObj: object) {
    if (resourceFileObj !== null) {
      this.loading = true;
      this.ResourcesDataSource = [];
      this.resourceService.getResourceFiles(JSON.stringify(resourceFileObj))
        .subscribe((resourceResponse: any) => {

          if (resourceResponse.length > 0) {
            this.ResourceFilesDataSource = resourceResponse.facilityEquipment;
            this.loading = false;

          } else {
            this.ResourceFilesDataSource = [];
            this.loading = false;
          }
        }, (respose: Response) => {
          this.loading = false;
          this.ResourceFilesDataSource = [];
          // handle error here
        });
    }
  }

  //Get Resources
  getResource(resourceFileObj: object) {
    if (resourceFileObj !== null) {
      this.ResourcesDataSource = [];
      this.loading = true;
      this.resourceService.getResources(JSON.stringify(resourceFileObj))
        .subscribe((resourceResponse: any) => {

          if (resourceResponse.length > 0) {
            this.ResourcesDataSource = resourceResponse.facilityEquipment;
            this.loading = false;

          } else {
            this.ResourcesDataSource = [];
            this.loading = false;
          }
        }, (respose: Response) => {
          this.loading = false;
          this.ResourcesDataSource = [];
          // handle error here
        });
    }
  }

  public onClickSaveSummaryBtn() {
    this.CreateResource();
    this.loadResourcesSP();
    this.displayAdminForm = true
    this.displaypreviewContent = false;
    this.hidePreview = true;
    this.isEdit = false;
    this.displayResourcesContent = false;

    //#region User Action Audit
    if (this.isLabResource) {
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.RESOURCE_HELP_POPUP,
        screenPath: location.pathname,
        key: '',
        value: '',
        eventDescription: UserActionDescription.LABRESOURCE_HELP_SAVE_CLICKED
      });
    }
    //#endregion
  }

  //CreateResource  
  CreateResource() {
    let resourceFileObj = {
      "UPDATERESOURCE": {
        "ResourceWikiId": "0",
        "isActiveFlag": "0",
        "IsLabResource": this.isLabResource
      },
      "CREATERESOURCE": {
        "WikiContent": '',
        "HTMLContent": this.htmlContent,
        "UserID": this.userDetail.userId,
        "IsLabResource": this.isLabResource
      }
    };
    this.resourceService.createResource(JSON.stringify(resourceFileObj))
      .subscribe((resourceResponse: any) => { }, (respose: Response) => {
        // handle error here
      });
  }

  //Create Resource File
  CreateResourceFile() {
    let resourceFileObj = {
      "CREATERESOURCEFILE": {
        "InsResourceFile": "",
        "ResourceFilePath": "",
        "ResourceFile": "",
      }
    };
    this.resourceService.createResourceFile(JSON.stringify(resourceFileObj))
      .subscribe((resourceResponse: any) => {
        this.getActiveResources();
      }, (respose: Response) => {
        // handle error here
      });
  }

  public onClickEditContentBtn() {
    this.isEdit = true;
    this.displayAdminForm = false
    this.displaypreviewContent = true;
    this.displayResourcesContent = true;
     //#region User Action Audit
    if (this.isLabResource) {
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.RESOURCE_HELP_POPUP,
        screenPath: location.pathname,
        key: '',
        value: '',       
        eventDescription:UserActionDescription.LABREOURCE_HELP_EDIT_HELP_CLICKED
      });
    }
    //#endregion
  }
  public closeResourcesPreview() {

    if (this.isEdit) {
      this.hidePreview = true;
      this.displayAdminForm = false
      this.displaypreviewContent = true;
      this.displayResourcesContent = true;
    }
    else {
      this.isEdit = false;
      this.hidePreview = true;
      this.getActiveResources();
      this.displayResourcesContent = false;
    }

  }
  onClickPreviewSummaryBtn() {
    this.displayAdminForm = true;
    this.hidePreview = false;
    if (this.htmlContent == null) {
      this.displaypreviewContent = true;
      this.displayResourcesContent = true;
      this.displayAdminForm = false;
      this.messageService.showAlertMessage("Error:Please enter content to preview");
      return false;
    } else {
      this.displaypreviewContent = false;
      this.displayResourcesContent = true;
      this.displayAdminForm = true;
    }
    //#region User Action Audit
    if (this.isLabResource) {
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.RESOURCE_HELP_POPUP,
        screenPath: location.pathname,
        key: '',
        value: '',       
        eventDescription:UserActionDescription.LABREOURCE_HELP_PREVIEW_CLICKED
      });
    }
    //#endregion
  }
  onClickCancelSummaryBtn() {
    //Reload Default
    this.isEdit = false;
    this.hidePreview = true;
    this.getActiveResources();
    this.displayAdminForm = true
    this.displaypreviewContent = true;
    this.displayResourcesContent = false;
    //#region User Action Audit
    if (this.isLabResource) {
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.RESOURCE_HELP_POPUP,
        screenPath: location.pathname,
        key: '',
        value: '',
        eventDescription:UserActionDescription.LABRESOURCE_HELP_CANCELED_CLICKED
      });
    }
    //#endregion

  }

  //Update Resource
  UpdateResource(resourceWikiId, isActiveFlag, callback) {

    let resourceFileObj = {
      "UPDATERESOURCERESET": {
        "ResourceWikiId": 0,
        "isActiveFlag": 0,
      },
      "UPDATERESOURCE": {
        "ResourceWikiId": resourceWikiId,
        "isActiveFlag": isActiveFlag,

      }
    };
    this.resourceService.updateResource(JSON.stringify(resourceFileObj))
      .subscribe((resourceResponse: any) => { callback(); }, (respose: Response) => {
        // handle error here
      });
  }

  onClickContentBtn() {
    this.hidePreview = true;
    if (this.resourceWikiId > 0) {
      this.isDisabled = false;
      this.isActiveFlag = 1;

      var tempmessage = '';
      tempmessage = 'Are you sure you want to restore ' + this.resourcesPreview + "?";

      this.confirmationService.confirm({
        message: tempmessage,
        accept: () => {
          //Actual logic to perform a confirmation
          this.UpdateResource(this.resourceWikiId, this.isActiveFlag, () => {
            this.loadResourcesSP();
            this.getActiveResources();
            this.displaypreviewContent = true;
            this.displayResourcesContent = false;
          });
        }
      });
    }
    else {
      this.isDisabled = true;
    }
  }
  public hasPermission() {
    let result: Boolean = false
    if (this.bartRoleCode == "ADMIN") {
      result = true;

    }
    return result
  }
}